
.chart {
  font-size: 0.65em;
  margin: 1em 0 3em -2.5em;
}

.chartDescription {
  margin: 0 0 0 5em;
}

.legend {
  margin-bottom: 1em;
}

.categoryColor {
  display: inline-block;
  margin-left: 5px;
  width: 30px;
  height: 10px;
  margin-top: 4px;
  margin-right: 10px;
}

.summary {
  font-size: 1rem;
  margin-top: 1em;
}
